import { runInAction } from 'mobx';
import { hasMaximumSelectedSites } from '../../selectors/sites/has-maximum-selected-sites';
import { browsingDomainStore } from '../../store';
export const addSelectedSite = (siteId) => {
    const selectedSiteIds = browsingDomainStore.data.selectedSiteIds;
    if (selectedSiteIds.find(s => s === siteId)) {
        return;
    }
    if (hasMaximumSelectedSites()) {
        throw Error(`Maximum number of selected sites reached. Cannot add site with ID ${siteId}`);
    }
    runInAction(() => browsingDomainStore.data.selectedSiteIds.push(siteId));
};
//# sourceMappingURL=add-selected-site.js.map